import { defineStore } from "pinia"

export const paymentStore = defineStore({
    id: 'paymentStore',
    state: () => ({
        paymentData: null
    }),
    actions: {
        setPaymentData(data) {
            this.paymentData = data
        },
        removePaymentData() {
            this.paymentData = null
        }
    },
    getters: {
        getPaymentData() {
            return this.paymentData
        }
    },
    persist: true
})